import { useI18n } from 'vue-i18n';
import type { DataTableHeader } from '@/types/vuetify';

export function createReportPageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        {
            title: t('report.customer'),
            value: 'login',
            key: 'login',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.betCount'),
            value: 'betCount',
            key: 'betCount',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('userBalance.bots'),
            value: 'settledBotCount',
            key: 'settledBotCount',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.staked'),
            value: 'stakeSum',
            key: 'stakeSum',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.turnover'),
            value: 'settledStakeSum',
            key: 'settledStakeSum',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('report.agentStaked'),
            value: 'settledStakeAgentSum',
            key: 'settledStakeAgentSum',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('report.commTurnover'),
            value: 'settledValidStakeSum',
            key: 'settledValidStakeSum',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('report.agentComm'),
            value: 'settledAgentCom',
            key: 'settledAgentCom',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('report.customerBalance'),
            value: 'balance',
            key: 'balance',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('report.agentBalance'),
            value: 'balanceAgentPc',
            key: 'balanceAgentPc',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('report.customerYield'),
            value: 'customerYield',
            key: 'customerYield',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('report.agentPl'),
            value: 'agentPl',
            key: 'agentPl',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('report.totalAgent'),
            value: 'totalAgent',
            key: 'totalAgent',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
    ];
}
